<template>
    <div>
        <el-row>
            <el-col>
                <el-card class="box-card">
                    <div class="text item">
                        <el-row class="info-item" @click.native="toParticulars(false)">
                            <el-col :span="13">
                                <el-row>
                                    <el-col class="image-col" :span="4">
                                        <el-image :src="src" class="image">
                                            <div slot="placeholder" class="image-slot">
                                                加载中<span class="dot">...</span>
                                            </div>
                                        </el-image>
                                    </el-col>
                                    <el-col :span="18" :offset="1" style="backgroundf-color:blue;">
                                        <h5>天黎优品科技有限公司</h5>
                                        <p>
                                            <span>人事部</span>|
                                            <span>20-99人</span>|
                                            <span>网络开发</span>
                                        </p>
                                    </el-col>
                                </el-row>
                            </el-col>
                            <el-col :span="5" :push="6" class="content-right">
                                <p>（15）个待招职位<i class="el-icon-arrow-right"></i></p>
                            </el-col>
                        </el-row>
                        <el-divider></el-divider>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    data(){
        return {
            src:'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg'
        }
    },
    methods:{
        toParticulars(status){
            this.$emit('statusFun',status)
        }
    },
    created(){
        this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
        this.axiosGet(`/generationRecruitPost/selectGenerationRecruitPost?id=${this.userInfo.id}`).then((res)=>{
            console.log('ress')
            console.log(res)
        })
    }
}
</script>
<style lang="less" scoped>
    .image-col{
        width:68px;
        .image{
            width:100%;
            height:68px;
        }
    }
    .info-item{
        padding:10px;
        cursor:pointer;
        h5{            
            font-size: 18px;
            font-weight: 500;
            color: #343434;
            line-height: 30px;
        }
        p{  
            margin-top:10px;
            color: #666666;
            span:first-of-type{
                padding-left:0;
            }
            span{
                padding:10px;        
                font-size: 14px;
                font-weight: 400; 
            }
        }
    }
    .content-right{
        p{
            font-size: 14px;
            font-weight: 500;
            color: #1A80FC;
            line-height: 45px;
            cursor:pointer;
            i{
                color:#343434;
                margin:0 5px;
            }
        }
    }
</style>